import {Field} from 'formik';


import {
    FormikSelect,
    FormikSwitch,
    FormikTextarea,
    FormikTextInput,
    PlatformFieldset
} from '@flexinet/ui-components';
import {Stack} from "@mantine/core";
import {CustomersAutocomplete} from "../../customers/inputs/CustomersAutocomplete.tsx";


export const FormComponent = () => {

    return (
        <Stack gap={'xl'}>

            <PlatformFieldset legend={'Indent Details'} variant={'filled'}>

                {/*
                  * ⚠️ MONEY PATH: the value typed here is sent to Stripe as
                  * MINOR UNITS — 1000 is $10.00, not $1,000. The field said
                  * only "Amount" and "Please enter the amount", which reads as
                  * major units to anyone who has not seen the schema.
                  *
                  * The BEHAVIOUR is unchanged (FNP-918 is compliance work, and
                  * dividing by 100 here would change what a keystroke charges).
                  * Making the unit explicit is the honest fix available without
                  * touching money movement.
                  */}
                <Field
                    name='amount'
                    label='Amount (minor units)'
                    description='In the currency’s smallest unit — enter 1000 for 10.00'
                    component={FormikTextInput}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='currency'
                    label='Currency'
                    description='Please enter currency'
                    component={FormikSelect}
                    data={[
                        {
                            value: 'usd',
                            label: 'USD'
                        },
                        {
                            value: 'eur',
                            label: 'EUR'
                        },
                    ]}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='description'
                    label='Description'
                    description='Please enter custome description'
                    component={FormikTextarea}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='customerId'
                    label='Customer'
                    description='Please enter customer'
                    component={CustomersAutocomplete}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='automaticPaymentMethods.enabled'
                    label='Automatic Payment Methods Is Enabled'
                    description='Please enable or disable automatic payment methods'
                    component={FormikSwitch}
                    data={[
                        {
                            value: 'true',
                            label: 'Enabled'
                        },
                        {
                            value: 'false',
                            label: 'Disabled'
                        },
                    ]}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='setupFutureUsage'
                    label='Setup Future Usage'
                    description='Please enter setup future usage'
                    component={FormikSelect}
                    data={[
                        {
                            value: 'offSession',
                            label: 'Off Session'
                        },
                        {
                            value: 'onSession',
                            label: 'On Session'
                        },
                    ]}
                    withAsterisk
                    my={'xl'}
                />


            </PlatformFieldset>

        </Stack>
    );
};
